import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ChevronRight } from "lucide-react";
import MobileShell from "@/components/MobileShell";
import SituationIcon, { accentFor } from "@/components/SituationIcon";
import client from "@/lib/api";
import { useLang } from "@/context/LangContext";

export default function SwitzerlandHub() {
  const nav = useNavigate();
  const { t } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => { client.get("/situations", { params: { switzerland: true } }).then(({ data }) => setItems(data)).catch(() => {}); }, []);

  return (
    <MobileShell>
      <div className="relative px-5 py-6">
        <div className="absolute -top-6 -right-8 w-40 h-40 rounded-full bg-red-500/15 blur-3xl" />
        <header className="flex items-center gap-3 mb-4 relative z-10">
          <button onClick={() => nav("/home")} data-testid="back-btn" className="w-10 h-10 rounded-full glass flex items-center justify-center text-slate-300 press"><ArrowLeft size={20} /></button>
          <div>
            <h1 className="font-heading text-2xl font-extrabold text-white flex items-center gap-2">Switzerland <span>🇨🇭</span></h1>
            <p className="text-sm text-slate-400">{t("sw_sub")}</p>
          </div>
        </header>

        <div className="glass rounded-3xl p-4 mb-5 relative z-10 border-red-400/20">
          <p className="text-slate-200 text-sm leading-relaxed">
            Practice the conversations you actually face in Switzerland — from <b className="text-white">Migros</b> and <b className="text-white">SBB</b> to the <b className="text-white">Gemeinde</b>, <b className="text-white">RAV</b> and your <b className="text-white">Krankenkasse</b>. We teach Standard German, with optional Swiss German hints inside each chat.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 relative z-10">
          {items.map((s) => {
            const c = accentFor(s.key, s.category);
            return (
              <button key={s.id} data-testid={`ch-situation-${s.key}`} onClick={() => nav(`/speaking/${s.id}`)}
                className="group glass rounded-2xl p-4 text-left press hover:border-white/20 flex flex-col gap-2">
                <span className="w-12 h-12 rounded-2xl flex items-center justify-center transition-transform group-active:scale-90"
                  style={{ background: `${c}22`, color: c, boxShadow: `0 6px 16px -8px ${c}` }}>
                  <SituationIcon name={s.icon} size={22} />
                </span>
                <span className="font-heading font-bold text-white leading-tight">{s.title}</span>
                <span className="text-xs text-slate-400 flex items-center gap-1">{t("level")} {s.difficulty} <ChevronRight size={12} /></span>
              </button>
            );
          })}
        </div>
      </div>
    </MobileShell>
  );
}
